// Data sevice
import axios from 'axios';
import authHeader from './auth-header';
import fileHeader from './file-header';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class ListingService {
  // index() {
  //     return axios.get(API_URL + 'listings', { headers: authHeader() })
  // }

  index(params = {}) {
    return axios.get(API_URL + 'listings', {
      headers: authHeader(),
      params, // ← This is the missing part
    });
  }

  show(id) {
    return axios.get(API_URL + 'listings/' + id, { headers: authHeader() });
  }
  store(resource) {
    return axios.post(API_URL + 'listings', resource, {
      headers: fileHeader(),
    });
  }
  update(resource) {
    return axios.put(API_URL + 'listings/' + resource.id, resource, {
      headers: fileHeader(),
    });
  }
  delete(resource) {
    return axios.delete(API_URL + 'listings/' + resource.id, {
      headers: authHeader(),
    });
  }

  getApprovedOpenListing() {
    return axios.get(API_URL + 'get-listings', { headers: authHeader() });
  }

  getListingByCategory(id) {
    return axios.get(API_URL + 'get-category-listings/' + id, {
      headers: authHeader(),
    });
  }

  getListingFile(id) {
    return axios.get(API_URL + 'files/' + id, { headers: authHeader() });
  }

  filterListing(resource) {
    return axios.post(API_URL + 'filter-listings', resource, {
      headers: fileHeader(),
    });
  }

  getUserListings(id) {
    return axios.get(API_URL + 'user-listings/' + id, {
      headers: authHeader(),
    });
  }

  inquireListing(resource) {
    return axios.post(API_URL + 'inquire-listing', resource, {
      headers: fileHeader(),
    });
  }

  approve(id) {
    return axios.post(
      `${API_URL}listings/${id}/approve`,
      {}, // ← empty payload
      { headers: authHeader() } // ← your Authorization header
    );
  }

  verify(id) {
    return axios.post(
      `${API_URL}listings/${id}/verify`,
      {}, // ← empty payload
      { headers: authHeader() } // ← your Authorization header
    );
  }

  decline(id, payload) {
    return axios.post(`${API_URL}listings/${id}/decline`, payload, {
      headers: authHeader(),
    });
  }

  dashboardStats() {
    return axios.get(`${API_URL}dashboard/stats`, { headers: authHeader() });
  }
  getAllListings(params = {}) {
    return axios.get(API_URL + 'all-listings', {
      headers: authHeader(),
      params,
    });
  }

  getCandidates(params = {}) {
    return axios.get(`${API_URL}candidates`, {
      headers: authHeader(),
      params,
    });
  }

  // getJobsPosted(params = {}) {
  //   return axios.get(`${API_URL}jobs-posted`, {
  //     headers: authHeader(),
  //     params,
  //   });
  // }

   getJobsPosted(params = {}) {
    return axios.get(`${API_URL}user-jobs-posted`, {
      headers: authHeader(),
      params,
    });
  }

 


  storeJobApplication(resource) {
    return axios.post(API_URL + 'job-applications', resource, {
      headers: fileHeader(resource), // 👈 pass resource so fileHeader can check it
    });
  }

  showJob(id) {
    return axios.get(API_URL + 'jobs-posted/' + id, { headers: authHeader() });
  }

  getSavedSearches(params = {}) {
    return axios.get(API_URL + 'searches', {
      headers: authHeader(),
      params,
    });
  }

  getAllJobsPosted(params = {}) {
    return axios.get(`${API_URL}jobs-posted`, {
      headers: authHeader(),
      params,
    });
  }
}
export default new ListingService();
